import { modelsModel } from './models-model'
import { z } from 'my-zod'
import { modelFamiliesModel } from '../model-family'

export const modelSystemView = modelsModel.augment({
  modelFamilyId: modelFamiliesModel.shape.id.nullable(),
  modelFamilyName: modelFamiliesModel.shape.modelFamilyName.nullable(),
  modelFamilyImageUrl: modelFamiliesModel.shape.modelFamilyImageUrl.nullable(),
  modelFamilyCapacity: modelFamiliesModel.shape.capacity.nullable()
})

export type modelSystemView = z.infer<typeof modelSystemView>
